import { userConstants } from "../constants/login.constants";

 function ebinderOrderRequest(state = {}, action) {
    switch (action.type) {
        case userConstants.EBINDERORDER_REQUEST:
            return {
                loading: true
            };
        case userConstants.EBINDERORDER_SUCCESS:
            return {
                items: action.ebinderOrderRequest
            };
        case userConstants.EBINDERORDER_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default ebinderOrderRequest;